"use strict";

import Vue from 'vue';
import axios from "axios";
import store from "@/store";

import { IMPROVE_CONFIG } from "@/config.js";

const token = localStorage.getItem("token");
const UNAUTHORIZED = 401;
const isAuthenticated = store.getters.isLoggedIn;

Vue.prototype.$axios = axios;

axios.defaults.baseURL = IMPROVE_CONFIG.API_URL;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

let config = {
  baseURL: IMPROVE_CONFIG.API_URL,
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    const { status } = error.response;
    if (isAuthenticated && status === UNAUTHORIZED) {
      store.commit("logout");
      this.$router.push("/logout");
    }
    return Promise.reject(error);
  }
);


axios.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response;
    if (store.getters.isLoggedIn && status === UNAUTHORIZED) {
      store.commit("logout");
      this.$router.push("/logout");
    }
    return Promise.reject(error);
  }
);
// Plugin.install = function(Vue, options) {  

Plugin.install = function(Vue) {  
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
